import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function TopNInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Take</FieldLabel>
      <Segmented
        value={c.from || 'top'}
        onChange={(v) => u({ from: v })}
        options={[
          { value: 'top', label: 'Top ▲' },
          { value: 'bottom', label: 'Bottom ▼' },
        ]}
      />
      <FieldLabel>How many rows</FieldLabel>
      <TextInput mono value={c.n ?? 10} onChange={(v) => u({ n: Number(v) })} type="number" />
      <FieldLabel>Per group (optional)</FieldLabel>
      <ColSelect value={c.groupBy} onChange={(v) => u({ groupBy: v })} placeholder="— ungrouped —" />
    </div>
  );
}
